import {React} from 'react'
import {MdOutlinePictureAsPdf} from 'react-icons/md'
// import {GrDocumentPdf} from 'react-icons/gr'
import {BsFillFileEarmarkBreakFill, BsFillImageFill,BsFileWord} from 'react-icons/bs'
import {SiMicrosoftexcel,SiAndroid} from 'react-icons/si'
import styles from './Icon.module.scss' 
function Icon({fileType}) {
    let fileIcon = <BsFillFileEarmarkBreakFill />

    if(fileType.includes("pdf")){
        fileIcon = <MdOutlinePictureAsPdf /> 
    }
    else if(fileType.includes("jpeg") || fileType.includes("png") || fileType.includes("jpg") || fileType.includes("jfif")){
        fileIcon = <BsFillImageFill />
    }
    else if(fileType.includes("document") || fileType.includes("docx")){
        fileIcon = <BsFileWord />
    }
    else if(fileType.includes("xls") || fileType.includes("xlxs")){
        fileIcon=<SiMicrosoftexcel />
    }
    else{
        fileIcon = <SiAndroid />
    }

  return (
    <div className= {styles.icon}>
        {fileIcon}
    </div>
  )
}

export default Icon